import { render, staticRenderFns } from "./RemoveTag.vue?vue&type=template&id=4c0ae2ea"
import script from "./RemoveTag.vue?vue&type=script&lang=js"
export * from "./RemoveTag.vue?vue&type=script&lang=js"
import style0 from "./RemoveTag.vue?vue&type=style&index=0&id=4c0ae2ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports